import * as React from 'react'
import {createStyles, Theme, WithStyles, withStyles, Typography, ExpansionPanel, ExpansionPanelSummary, ExpansionPanelDetails, Table, TableHead, TableRow, TableCell, TableBody, Icon} from '@material-ui/core'
import {withI18n, WithI18n} from 'src/core/i18n/withI18n'
import {compose} from "redux";
import { RootState } from 'src/core/redux/reducer'
import { connect } from 'react-redux'
import { formatDate } from 'src/core/i18n/date'
import Alert from 'src/shared/Alert/Alert'

const styles = (t: Theme) => createStyles({
  expansionPnl: {
    boxShadow: 'none',
    '&:before': {
      display: 'none'
    },
  },
  title: {
    textTransform: 'uppercase'
  },
  xsScroll: {
    [t.breakpoints.down('sm')]: {
      overflow: 'auto'
    },
  }
});


interface IProps extends WithStyles<typeof styles>,
  WithI18n,
  ReturnType<typeof state2props>,
  ReturnType<typeof dispatch2props> {
}

class EnterpriseDocuments extends React.Component<IProps, any> {


  render(){
    const { t, classes, enterprise } = this.props;
    return(
      <>
        <Alert type="info">{t.EnterpriseDetail_doc_warning}</Alert>
        <br/>
        <ExpansionPanel defaultExpanded={true} className={classes.expansionPnl}>
          <ExpansionPanelSummary expandIcon={<Icon>expand_more</Icon>}>
            <Typography variant="subtitle2" className={classes.title}>{t.EnterpriseDetail_status_of_document_contractual}</Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails className={classes.xsScroll}>
            {enterprise.legal_pack_docs &&
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>{t.EnterpriseDetail_doc_name}</TableCell>
                    <TableCell>{t.EnterpriseDetail_signed_on}</TableCell>
                    <TableCell>{t.EnterpriseDetail_delivered_on}</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {enterprise.legal_pack_docs.docs.map(row => {
                    return (
                      <TableRow key={row.id}>
                        <TableCell key={`${row.id}-name`} component="th" scope="row">{row.name}</TableCell>
                        <TableCell key={`${row.id}-signature-date`}>{this.getDate(row.signature_date)}</TableCell>
                        <TableCell key={`${row.id}-delivery-date`}>{this.getDate(row.delivery_date)}</TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            }
            {enterprise.legal_pack_docs === undefined &&
              t.not_available
            }
          </ExpansionPanelDetails>
        </ExpansionPanel>
      </>
    )
  }

  getDate = (date) => {
    return (!!date && date.length > 0) ? formatDate(new Date(date)) : "-"
  }
}

const state2props = (state: RootState) => ({
  enterprise: state.accountInfo.enterpriseSelected
});

const dispatch2props = dispatch => ({
});

export default compose(
  withI18n,
  connect(state2props, dispatch2props),
  withStyles(styles)
)(EnterpriseDocuments)



// WEBPACK FOOTER //
// ./src/page/Consumer/Enterprise/cards/EnterpriseDocuments.tsx